import { render } from "./Header.vue?vue&type=template&id=8ed622e6"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "E:\\VUE\\Extreme Solutions Jawed Projects\\Extreme Solutions Jawed Projects\\WinWin\\WinWin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__